import { SVGProps } from 'react'

const LongTermIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_9255_41077)">
        <path
          d="M37 31C37 32.654 35.654 34 34 34V35C34 35.553 33.552 36 33 36C32.448 36 32 35.553 32 35V34H31.732C30.665 34 29.669 33.426 29.134 32.501C28.858 32.022 29.021 31.411 29.499 31.135C29.976 30.857 30.589 31.022 30.865 31.499C31.044 31.809 31.376 32 31.732 32H34C34.551 32 35 31.552 35 31C35 30.621 34.729 30.302 34.356 30.239L31.315 29.733C29.973 29.509 29 28.359 29 27C29 25.346 30.346 24 32 24V23C32 22.447 32.448 22 33 22C33.552 22 34 22.447 34 23V24H34.268C35.335 24 36.331 24.574 36.866 25.499C37.142 25.978 36.979 26.589 36.501 26.865C36.024 27.143 35.412 26.979 35.135 26.501C34.956 26.191 34.624 26 34.268 26H32C31.449 26 31 26.448 31 27C31 27.379 31.271 27.698 31.644 27.761L34.685 28.267C36.027 28.491 37 29.641 37 31ZM27.403 33.503C27.002 32.808 26.895 31.999 27.101 31.226C27.246 30.686 27.53 30.208 27.925 29.832C27.34 29.036 27 28.055 27 27C27 24.586 28.721 22.566 31 22.101V19C31 16.243 28.757 14 26 14H25.829C25.416 12.836 24.304 12 23 12H21C19.696 12 18.584 12.836 18.171 14H18C15.243 14 13 16.243 13 19V31C13 33.757 15.243 36 18 36H26C27.068 36 28.054 35.657 28.867 35.084C28.279 34.673 27.773 34.142 27.403 33.503ZM22.727 26.207L20.548 28.386C20.139 28.795 19.602 28.999 19.065 28.999C18.528 28.999 17.991 28.795 17.582 28.386L16.294 27.097C15.903 26.706 15.903 26.073 16.294 25.683C16.685 25.292 17.317 25.292 17.708 25.683L18.996 26.972C19.029 27.005 19.101 27.005 19.135 26.972L21.314 24.793C21.705 24.402 22.337 24.402 22.728 24.793C23.119 25.184 23.118 25.816 22.727 26.207ZM22.727 20.207L20.548 22.386C20.139 22.795 19.602 22.999 19.065 22.999C18.528 22.999 17.991 22.795 17.582 22.386L16.294 21.097C15.903 20.706 15.903 20.073 16.294 19.683C16.685 19.292 17.317 19.292 17.708 19.683L18.996 20.972C19.029 21.005 19.101 21.005 19.135 20.972L21.314 18.793C21.705 18.402 22.337 18.402 22.728 18.793C23.119 19.184 23.118 19.816 22.727 20.207Z"
          fill="#7181FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_9255_41077">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(13 12)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LongTermIcon
